import { FC } from "react";
import { Box, createStyles, makeStyles, Typography } from "@material-ui/core";

import { Desktop, Mobile } from "containers/Responsive";
import theme from "theme";

interface InfoBoxProps {
  title: string;
  info: string;
  mobile?: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    infoBoxTitle: {
      fontSize: "1rem",
      lineHeight: "10px",
    },
    infoBoxInfo: {
      fontSize: "2.8rem",
      fontWeight: theme.typography.fontWeightLight,
      color: theme.palette.text.primary,
    },
    desktopContainer: {
      marginRight: theme.spacing(9),
    },
    mobileContainer: {
      width: "100%",
      marginBottom: theme.spacing(3.75),
    },
  }),
);

const InfoBox: FC<InfoBoxProps> = ({ title, info }) => {
  const classes = useStyles();

  return (
    <>
      <Desktop>
        <Box className={classes.desktopContainer}>
          <Typography className={classes.infoBoxTitle}>{title}</Typography>
          <Typography className={classes.infoBoxInfo}>{info}</Typography>
        </Box>
      </Desktop>
      <Mobile>
        <Box className={classes.mobileContainer}>
          <Typography className={classes.infoBoxTitle}>{title}</Typography>
          <Typography className={classes.infoBoxInfo}>{info}</Typography>
        </Box>
      </Mobile>
    </>
  );
};

export default InfoBox;
